import plumbing1 from '../../assets/plumbing/plumbing_1.jpg'
import plumbing2 from '../../assets/plumbing/plumbing_2.jpg'
import plumbing3 from '../../assets/plumbing/plumbing_3.JPG'
import plumbing4 from '../../assets/plumbing/plumbing_4.jpg'
import plumbing5 from '../../assets/plumbing/plumbing_5.jpg'
import plumbing6 from '../../assets/plumbing/plumbing_6.jpg'
import plumbing7 from '../../assets/plumbing/plumbing_6_after.jpg'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation,Autoplay } from 'swiper/modules'
import React from 'react'

function Plumbings() {
  return (
    <>
    <div className='wavy-hero-container'>
                    <img src={plumbing1} className='wavy-hero-img' alt='hero'/>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave'><path fill="var(--dark)" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave-1'><path fill="#f6f6f6" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <div className='wavy-title'>
                        <p id='services' data-aos="slide-right">SERVICES</p>

                        <p data-aos="slide-left">PLUMBING</p>
                    </div>
    </div>








    <div className='service-intro'>
        <div className='service-intro-container'>
            <div className='service-intro-text'>
                <div data-aos="fade-right" className='service-intro-text-wrapper'>
                    <div className='service-intro-text-title'>The <b>MOST</b> Reliable Plumbing In DFW </div>
                    <div className='service-intro-text-sub'>Over 50+ Plumbing Clients in DFW</div>
                    <div className='service-intro-text-p' >Transform your bathroom’s plumbing system into a modern, efficient, and long-lasting setup with Home Service Experts, where exceptional craftsmanship and attention to detail ensure your project is done right the first time. Whether you’re planning a full plumbing overhaul or targeted upgrades, we work closely with you to design a system that fits your home’s needs and your lifestyle. From installing new pipes, water lines, and fixtures to upgrading water heaters, rerouting plumbing during remodels, and improving overall efficiency, every aspect is handled with precision and care. Our team ensures your plumbing is not only reliable and functional but built to serve you for years to come.</div>
                    <a href='tel:+14697284201'>
                        <button className='service-intro-text-btn'>GET A QUOTE</button>
                    </a>
                </div>
            </div>
            <img src={plumbing3} data-aos="fade-left" style={{"objectPosition":"top"}} alt='panel'/>
        </div>
    </div>









    <div className='service-cards'>
        <p className='service-cards-title' data-aos="fade">Plumbing Services <span className='service-cards-accent'>Tailored to Your Home</span></p>
        <p className='service-cards-subtitle' data-aos="fade">Discover The Many Ways Our Plumbing Services Can Improve Your Home</p>
        <div className='service-cards-wrapper'>

            <div className='service-cards-card' data-aos="flip-right">
                <img src={plumbing5} alt='card 1'/>


                <div className='service-cards-card-title'>
                    Plumbing Installations & Upgrades: Built for Reliability and Efficiency

                </div>
                <div className='service-cards-card-subtitle'>
                    Modern Solutions for a Better-Running Home

                </div>

                <div className='service-cards-card-p'>
                    At Home Service Experts, we provide full-service plumbing installations and upgrades for remodels, new construction, and system improvements. From new pipes and fixtures to water heater installations and complete system overhauls, we ensure your home’s plumbing is efficient, durable, and designed to meet today’s standards. Every project is tailored to your needs, delivering reliable performance and long-lasting value.

                </div>
            </div>



            <div className='service-cards-card' data-aos="flip-right">
                <img src={plumbing2} alt='card 2'/>

                <div className='service-cards-card-title'>
                    Fast, Reliable Plumbing Repairs: Restoring Your Home’s Comfort
                </div>

                <div className='service-cards-card-subtitle'>
                    Quick Diagnostics. Lasting Solutions.
                </div>

                <div className='service-cards-card-p'>
                    Plumbing issues can disrupt your routine and lead to costly damage if left unresolved. Our team delivers prompt, dependable repair services for leaks, clogs, burst pipes, water heater failures, and more. Using advanced diagnostic tools, we pinpoint problems quickly and provide effective repairs that restore your system’s functionality and protect your home.
                </div>
            </div>




            <div className='service-cards-card' data-aos="flip-right">
                <img src={plumbing7} alt='card 3'/>
                <div className='service-cards-card-title'>Pool Leak Detection & Pipe Replacement: Protecting Your Property</div>
                <div className='service-cards-card-subtitle'>
                    Precision Testing. Expert Repairs. Complete Peace of Mind.
                </div>
                <div className='service-cards-card-p'>
                    Home Service Experts also specializes in pool leak detection, plumbing repairs, and pipe replacement. Whether you’re dealing with hidden leaks, damaged plumbing lines, or failing pool equipment, our technicians use advanced technology to locate issues with accuracy and deliver long-lasting solutions. We help keep your pool operating efficiently while preventing unnecessary water loss and costly damage.
                </div>
            </div>




        </div>
    </div>









    <div className='service-cta'>
        <div className='service-cta-container'>
            <div className='service-cta-text'>
                <div>
                    <p className='service-cta-text-title' data-aos="fade">Start Your Plumbing <b>Upgrade Today</b></p>
                    <p className='service-cta-text-subtitle' data-aos="fade">If you’re ready to upgrade or remodel your home’s plumbing, contact Home Service Experts today. Our team is here to discuss your project, answer any questions, and provide a free, no-obligation estimate to help you get started.</p>
                </div>
                <a href='tel:+14697284201'>
                    <button className='service-cta-text-button' data-aos="fade">CALL NOW</button>
                </a>
            </div>
            {/* <img className="service-cta-image" alt='service' src={bath6}/> */}
        </div>
    </div>













    <div className='service-portfolio'>
        <div className='service-portfolio-header'>
            <div className='service-portfolio-header-title' data-aos="fade"><b>Real</b> Projects. <b>Real</b> Results.</div>
            <div className='service-portfolio-header-subtitle' data-aos="fade">Explore our recent plumbing remodeling projects and see how expert workmanship enhances the performance, efficiency, and reliability of every home we service. Each project is completed with precision and long-lasting quality—ensuring your plumbing system supports modern living at its finest.</div>
        </div>
        <div className='service-portfolio-slides'>
            <Swiper
            breakpoints={{
                1200:{
                    slidesPerView: 3,
                  spaceBetween: 15
                },
                900:{
                    slidesPerView: 2

                },
                550:{
                    slidesPerView: 1,

                    spaceBetween: 15
                }
                ,
                0: {
                //   slidesPerView: 2,

                  spaceBetween: 5
                }
              }}
              freeMode={true}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 5000, // Delay in milliseconds (3 seconds)
                disableOnInteraction: true, // Continue autoplay after user interactions
                pauseOnMouseEnter: true, // Pause autoplay on mouse hover
              }}
              modules={[FreeMode, Pagination, Navigation, Autoplay]}
              style={{padding:"20px"}} data-aos="zoom-in">
                <SwiperSlide>
                    <img src={plumbing1} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src={plumbing2} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                                <SwiperSlide>
                    <img src={plumbing3} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                                <SwiperSlide>
                    <img src={plumbing4} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                                <SwiperSlide>
                    <img src={plumbing5} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                                <SwiperSlide>
                    <img src={plumbing6} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                                <SwiperSlide>
                    <img src={plumbing7} alt='Bathroom gallery 2'/>
                </SwiperSlide>
                

            </Swiper>
        </div>










    </div>




















    </>
  )
}

export default Plumbings